import React from 'react';
import { Link } from 'react-router-dom';

const services = [
    { title: "Cab Services", path: "/cab-services", img: "/service1.jpg", features: ["Airport Transfers", "Corporate Travel", "City Tours", "Long Distance Travel"] },
    { title: "Real Estate Services", path: "/real-estate", img: "/service2.jpg", features: ["Office Leasing", "Residential Apartments", "Property Management", "Relocation Assistance"] },
    { title: "Business Setup Services", path: "/business-setup", img: "/service3.jpg", features: ["Company Registration", "Legal Documentation", "Compliance Support", "HR & Recruitment"] },
    { title: "Packers & Movers", path: "/packers-movers", img: "/service4.jpg", features: ["Local & Long Distance Moving", "Packing Services", "Relocation Support", "Storage Solutions"] },
    { title: "Company Registration", path: "/registration", img: "/service5.jpg", features: ["Complete assistance for company incorporation", "Legal documentation"] },
    { title: "Compliance & Government Approvals", path: "/compliance", img: "/service6.jpg", features: ["Support for licenses", "Registrations", "Regulatory compliance"] },
    {
        title: "Organic Magnetic Pyrolysis System",
        path: "/pyrolysis-system",
        img: "/mg22eh-machine.jpg",
        features: [
            "Eco-friendly waste decomposition",
            "24/7 automatic operation",
            "Converts waste to steam & energy",
            "No fossil fuels required"
        ]
    },
    {
        title: "JLPT Course (Agra)",
        path: "/jlpt-course",
        img: "/jlpt-course.jpg", // Yahan apni JLPT ki image ka naam likhein
        features: ["N5 to N1 Levels", "Online & Offline", "Job Placement Support"]
    }
];
const CoreServices = () => {
    return (
        <section className="py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-6 text-center">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12">EXPLORE OUR CORE SERVICES</h2>

                {/* Grid Container */}
                <div className="flex flex-col md:flex-row h-auto md:h-[500px] gap-2">
                    {services.map((service, index) => (
                        <Link
                            to={service.path} // Yahan humne path define kiya hai
                            key={index}
                            className="relative w-full h-[250px] md:h-full md:flex-[1] transition-all duration-700 ease-in-out md:hover:flex-[4] rounded-xl overflow-hidden shadow-lg group border border-gray-200"
                        >
                            {/* Background Image */}
                            <div
                                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
                                style={{ backgroundImage: `url(${service.img})` }}
                            />
                            {/* Overlay */}
                            <div className="absolute inset-0 bg-black/50 group-hover:bg-black/60 transition-all duration-500" />

                            {/* Content */}
                            <div className="absolute bottom-6 left-6 right-6 text-left text-white">
                                <h3 className="text-xl font-bold mb-2">{service.title}</h3>
                                <div className="w-12 h-1 bg-[#f15a24] mb-3"></div>

                                {/* Features List */}
                                <ul className="hidden md:block opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200 text-xs space-y-1">
                                    {service.features.map((feat, i) => (
                                        <li key={i}>• {feat}</li>
                                    ))}
                                </ul>

                                {/* Read More Button */}
                                <span className="block mt-2 text-[10px] font-bold uppercase tracking-widest text-blue-300 group-hover:text-white transition-colors">
                                    Read More →
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CoreServices;